import React from "react";
import { VstLoader } from "vstui";
import Utils from "../utils/utils";
import Price from "./price";
import TransactionAction from "../actions/transaction-action";
import { Table } from "@vitalsource/vstui";

const PurchasesController = ({ purchases }) => {
  const _purchaseTotal = t => {
    let p = parseFloat(t.total);
    return Math.abs(p);
  };

  const _onDetailClick = e => {
    e.preventDefault();
    let number = e.currentTarget.dataset.number;
    TransactionAction.showDetails(number);
  };

  const transactionTotal = t => {
    let p = parseFloat(t.total);
    return Math.abs(p);
  };

  const onDetailClick = e => {
    e.preventDefault();
    let number = e.currentTarget.dataset.number;
    TransactionAction.showDetails(number);
  };

  const renderTableRows = purchases => {
    const tableRows = purchases.map((transaction, index) => {
      return {
        date: {
          content: Utils.toDateString(transaction.orderDate),
          sort: transaction.orderDate
        },
        confirmation: transaction.number,
        sort: transactionTotal(transaction),
        total: {
          content: (
            <Price price={transaction.total} currency={transaction.currency} />
          ),
          sort: transaction.total
        },
        details: (
          <a
            className="details-link"
            href={`/transactions/${transaction.number}`}
            data-number={transaction.number}
            onClick={onDetailClick}
          >
            <span>{i18n.t("transactions.details-refund")}</span>
          </a>
        )
      };
    });
    return tableRows;
  };

  const renderTableHeaders = () => {
    return [
      {
        header: i18n.t("transactions.purchased"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "date"
      },
      {
        header: i18n.t("transactions.confirmation#"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "confirmation"
      },
      {
        header: i18n.t("transactions.total"),
        numeric: false,
        hiddenHeader: false,
        rowKey: "total"
      },
      { header: "", numeric: false, hiddenHeader: false, rowKey: "details" }
    ];
  };

  if (purchases) {
    if (purchases.length > 0) {
      const tableHeaders = renderTableHeaders();
      const tableRows = renderTableRows(purchases);

      return <Table fullWidth columns={tableHeaders} rows={tableRows} />;
    } else {
      return <p>{i18n.t("transactions.no-purchases")}</p>;
    }
  } else {
    return (
      <div className="deck">
        <VstLoader />
      </div>
    );
  }
};

export default PurchasesController;



/** WEBPACK FOOTER **
 ** ./src/js/components/purchases-container.jsx
 **/